import Head from 'next/head'
import styles from "../styles/pages/Restaurant.module.scss"
import Topbanner from '../components/Topbanner/Topbanner';
import PageGalleryComp from '../components/PageGalleryComp/PageGalleryComp';

export default function Gallery() {

    const galleryImages = [

        // Facade
        {
            bgImage: "/images/page-gallery/facade/8.jpg",
        altText: "The Twin Towers Hotel View Image 3",
            category: 'facade',
        },
        {
            bgImage: "/images/page-gallery/facade/17.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: 'facade',
        },
        // Rooms
        {
            bgImage: "/images/page-gallery/rooms/executive/1.jpg",
            altText: "The Twin Towers Hotel Room Image 1",
            category: 'rooms',
        },
        {
            bgImage: "/images/page-gallery/rooms/executive/2.jpg",
            altText: "The Twin Towers Hotel Room Image 6",
            category: 'rooms',
        },

        // Dining
        {
            bgImage: "/images/page-gallery/dining/8.jpg",
            altText: "The Twin Towers Hotel dining Image 8",
            category: "dining"
        },
        {
            bgImage: "/images/page-gallery/dining/2.jpg",
            altText: "The Twin Towers Hotel dining Image 3",
            category: 'dining',
        },

        // Meeting
        {
            bgImage: "/images/page-gallery/wedding-events/1.jpg",
            altTest: "Wedding image 1",
            category: 'wedding_&_events',
        },

        // View
        {
            bgImage: "/images/page-gallery/views/2.jpg",
            altText: "The Twin Towers Hotel View Image 2",
            category: 'property_view',
        },

        // Wildlife Nature
        {
            bgImage: "/images/page-gallery/wild-nature/2.jpg",
            altText: "The Twin Towers Hotel View Image 2",
            category: 'wildlife_&_nature',
        },


        // Rooms
        // {
        //     bgImage: "/images/page-gallery/rooms/family-room/1.jpg",
        //     altText: "The Twin Towers Hotel Room Image 1",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/deluxe/3.jpg",
            altText: "The Twin Towers Hotel Room Image 6",
            category: 'rooms',
        },
        {
            bgImage: "/images/page-gallery/rooms/deluxe/4.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: 'rooms',
        },
        // {
        //     bgImage: "/images/page-gallery/rooms/deluxe/5.jpg",
        //     altText: "The Twin Towers Hotel Room Image 2",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/family-room/3.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: 'rooms',
        },
        // {
        //     bgImage: "/images/page-gallery/rooms/premier/1.jpg",
        //     altText: "The Twin Towers Hotel Room Image 2",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/premier/2.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: 'rooms',
        },
        {
            bgImage: "/images/page-gallery/rooms/premier/4.jpg",
            altText: "The Twin Towers Hotel Room Image 2",
            category: 'rooms',
        },
        // {
        //     bgImage: "/images/page-gallery/rooms/wash-room/3.jpg",
        //     altText: "The Twin Towers Hotel wash room Image 2",
        //     category: 'rooms',
        // },
        {
            bgImage: "/images/page-gallery/rooms/wash-room/6.jpg",
            altText: "The Twin Towers Hotel wash room Image 2",
            category: 'rooms',
        },

        // Dining
        {
            bgImage: "/images/page-gallery/dining/1.jpg",
            altText: "The Twin Towers Hotel dining Image 1",
            category: 'dining',
        },
        {
            bgImage: "/images/page-gallery/dining/3.jpg",
            altText: "The Twin Towers Hotel dining Image 3",
            category: "dining"
        },
        // {
        //     bgImage: "/images/page-gallery/dining/4.jpg",
        //     altText: "The Twin Towers Hotel dining Image 4",
        //     category: "dining"
        // },
        // {
        //     bgImage: "/images/page-gallery/dining/5.jpg",
        //     altText: "The Twin Towers Hotel dining Image 5",
        //     category: "dining"
        // },
        {
            bgImage: "/images/page-gallery/dining/6.jpg",
            altText: "The Twin Towers Hotel dining Image 6",
            category: "dining"
        },
        {
            bgImage: "/images/page-gallery/dining/7.jpg",
            altText: "The Twin Towers Hotel dining Image 7",
            category: "dining"
        },
        // {
        //     bgImage: "/images/page-gallery/dining/9.jpg",
        //     altText: "The Twin Towers Hotel dining Image 9",
        //     category: "dining"
        // },
        // {
        //     bgImage: "/images/page-gallery/dining/10.jpg",
        //     altText: "The Twin Towers Hotel dining Image 10",
        //     category: "dining"
        // },
        {
            bgImage: "/images/page-gallery/dining/11.jpg",
            altText: "The Twin Towers Hotel dining Image 11",
            category: "dining"
        },
        // {
        //     bgImage: "/images/page-gallery/dining/12.jpg",
        //     altText: "The Twin Towers Hotel dining Image 12",
        //     category: "dining"
        // },

        // Facade
        // {
        //     bgImage: "/images/page-gallery/facade/1.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 1",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/2.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 2",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/4.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 4",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/5.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 5",
        //     category: "facade"
        // },
        {
            bgImage: "/images/page-gallery/facade/6.jpg",
            altText: "The Twin Towers Hotel Facade Image 6",
            category: "facade"
        },
        // {
        //     bgImage: "/images/page-gallery/facade/7.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 7",
        //     category: "facade"
        // },
        {
            bgImage: "/images/page-gallery/facade/8.jpg",
            altText: "The Twin Towers Hotel Facade Image 8",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/9.jpg",
            altText: "The Twin Towers Hotel Facade Image 9",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/10.jpg",
            altText: "The Twin Towers Hotel Facade Image 10",
            category: "facade"
        },
        {
            bgImage: "/images/page-gallery/facade/11.jpg",
            altText: "The Twin Towers Hotel Facade Image 11",
            category: "facade"
        },
        // {
        //     bgImage: "/images/page-gallery/facade/12.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 12",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/13.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 13",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/14.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 14",
        //     category: "facade"
        // },
        // {
        //     bgImage: "/images/page-gallery/facade/15.jpg",
        //     altText: "The Twin Towers Hotel Facade Image 15",
        //     category: "facade"
        // },
        {
            bgImage: "/images/page-gallery/facade/16.jpg",
            altText: "The Twin Towers Hotel Facade Image 16",
            category: "facade"
        },

        // Wedding Events
        {
            bgImage: "/images/page-gallery/wedding-events/4.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 4",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/2.jpg",
            altTest: "Wedding image 2",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/5.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 5",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/6.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 6",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/7.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 7",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/8.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 8",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/9.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 9",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/10.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 10",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/11.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 11",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/12.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 12",
            category: 'wedding_&_events',
        },
        {
            bgImage: "/images/page-gallery/wedding-events/13.jpg",
            altTest: "The Twin Towers Hotel Wedding and events Image 13",
            category: 'wedding_&_events',
        },

        // Property View
        {
            bgImage: "/images/page-gallery/views/3.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/4.jpg",
            altText: "The Twin Towers Hotel View Image 4",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/5.jpg",
            altText: "The Twin Towers Hotel View Image 5",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/6.jpg",
            altText: "The Twin Towers Hotel View Image 6",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/7.jpg",
            altText: "The Twin Towers Hotel View Image 7",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/8.jpg",
            altText: "The Twin Towers Hotel View Image 8",
            category: "property_view"
        },
        {
            bgImage: "/images/page-gallery/views/background.jpg",
            altText: "The Twin Towers Hotel View Image 10",
            category: "property_view"
        },

        // Wildlife Nature
        {
            bgImage: "/images/page-gallery/wild-nature/3.jpg",
            altText: "The Twin Towers Hotel View Image 3",
            category: 'wildlife_&_nature',
        },
        {
            bgImage: "/images/page-gallery/wild-nature/4.jpg",
            altText: "The Twin Towers Hotel View Image 4",
            category: 'wildlife_&_nature',
        },
        {
            bgImage: "/images/page-gallery/wild-nature/5.jpg",
            altText: "The Twin Towers Hotel View Image 5",
            category: 'wildlife_&_nature',
        },
        {
            bgImage: "/images/page-gallery/wild-nature/6.jpg",
            altText: "The Twin Towers Hotel View Image 6",
            category: 'wildlife_&_nature',
        },
    ];

    return (
        <>
            <Head>
                <title>Gallery | The Twin Towers Hotel in Kufri, Shimla</title>
                <meta name="description" content="Discover our carefully selected collection of beautiful images highlighting our wide range of offerings - The Twin Towers Hotel in Shimla" />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/gallery" />
                {/* <meta name="keywords" content="Kufri Adventure Resort, Best Hotels In Kufri, Shimla Hotel Booking, Restaurant In Shimla, Top Restaurants Shimla, bar club, resorts near shimla, hotels restaurants, family dining restaurants, hotels & resorts in shimla, restaurants shimla, restaurant hotels, Best Restaurants in Shimla "></meta> */}
            </Head>

            {/* <Topbanner bgImage={'/images/banners/gallery-page-banner.png'} title={'Gallery'} /> */}

            <section className={`${styles.gallery_sec} common_padding`}>
                <div className='container  '>
                    <div className={`${styles.gallery_sec_heading} text-center common_title pt-5`}>
                        <h1>Gallery</h1>
                        <h2>Explore our curated collection of stunning images showcasing our diverse offerings</h2>
                    </div>
                    <PageGalleryComp galleryImages={galleryImages} />
                </div>
            </section>
        </>
    )
}



